// @flow
import React from 'react';
import { getPublicAssets } from 'utils/assetsUtils';
import Breadcrumb from 'components/fragments/Breadcrumb';
import Label from 'components/fragments/text/Label';
import { ffrName } from 'utils/ffrNameUtils';

type Props = {
  name: string,
  tags: string[],
  teams: number,
  competitions: string[],
  logo: string,
  city: string
};

const ClubTop = (props: Props) => (
  <React.Fragment>
    <Breadcrumb
      breadcrumbStyle="mt-3"
      elements={[
        { name: 'accueil', to: '/' },
        { name: 'trouver un club', to: '/trouver-un-club-de-rugby' },
        ffrName(props.name)
      ]}
    />
    <div className="club mt-6 mb-6 mb-md-4 mb-lg-7">
      <img className="club__logo" src={getPublicAssets(props.logo)} alt={`Logo du club ${ffrName(props.name)}`} />
      <h1 className="club__title">{`${ffrName(props.name)} - ${props.city}`}</h1>
      <div className="club__label">
        {props.tags.map((tag, index) => (
          <Label isRounded isGrey label={tag} key={index} />
        ))}
      </div>
      <ul className="club__stat">
        {props.teams !== 0 && (
          <li>
            <i className="icon icon-jersey is-inline" />
            {props.teams} équipe(s)
          </li>
        )}
        {props.competitions.length > 0 && (
          <li>
            <i className="icon icon-trophy is-inline" />
            {props.competitions.length} championnat(s)
          </li>
        )}
      </ul>
    </div>
  </React.Fragment>
);

export default ClubTop;
